import { FC } from "react";
import { StaffConfirmationModal } from "../../../../features/staffAccessManagement";

interface IStaffProfileModalsProps {
    staffName: string;
    resetPasswordModalOpen: boolean;
    setResetPasswordModalOpen: (open: boolean) => void;
    deleteUserModalOpen: boolean;
    setDeleteUserModalOpen: (open: boolean) => void;
    onResetPassword: () => void;
    onDeleteUser: () => void;
    isResetPasswordLoading: boolean;
    isDeleteUserLoading: boolean;
}

export const StaffProfileModals: FC<IStaffProfileModalsProps> = ({
    staffName,
    resetPasswordModalOpen,
    setResetPasswordModalOpen,
    deleteUserModalOpen,
    setDeleteUserModalOpen,
    onResetPassword,
    onDeleteUser,
    isResetPasswordLoading,
    isDeleteUserLoading,
}) => (
    <>
        <StaffConfirmationModal
            open={resetPasswordModalOpen}
            setOpen={setResetPasswordModalOpen}
            title={`Сбросить пароль для сотрудника ${staffName}?`}
            onConfirm={onResetPassword}
            type="send"
            isLoading={isResetPasswordLoading}
        />
        <StaffConfirmationModal
            open={deleteUserModalOpen}
            setOpen={setDeleteUserModalOpen}
            title={`Удалить сотрудника ${staffName}?`}
            onConfirm={onDeleteUser}
            type="delete"
            isLoading={isDeleteUserLoading}
        />
    </>
)
